import { addLocation } from "@redotech/redo-merchant-fulfillment-rpc/schema/add-location";
import { deleteLocation } from "@redotech/redo-merchant-fulfillment-rpc/schema/delete-location";
import { getLocations } from "@redotech/redo-merchant-fulfillment-rpc/schema/get-locations";
import { getLocationsForRoutingRules } from "@redotech/redo-merchant-fulfillment-rpc/schema/get-locations-for-routing-rules";
import { getLocationsWithFulfillsFor } from "@redotech/redo-merchant-fulfillment-rpc/schema/get-locations-with-fulfills-for";
import { updateLocation } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-location";
import { updateLocationShippingName } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-location-shipping-name";
import {
  disconnectAims360Integration,
  getAims360Integration,
  getAllShipViaCodes,
  setAims360Integration,
  updateAims360Integration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/aims360";
import {
  disconnectApparelMagicIntegration,
  getApparelMagicIntegration,
  setApparelMagicIntegration,
  updateApparelMagicIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/apparel-magic";
import {
  disconnectAuthorizeNetIntegration,
  getAuthorizeNetIntegration,
  setAuthorizeNetIntegration,
  updateAuthorizeNetIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/authorizenet";
import {
  disconnectBlueYonderIntegration,
  getBlueYonderIntegration,
  setBlueYonderIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/blue-yonder";
import { disconnectCreditsYardIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/creditsyard/disconnect-creditsyard-integration";
import { getCreditsYardIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/creditsyard/get-creditsyard-integration";
import { setCreditsYardIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/creditsyard/set-creditsyard-integration";
import { updateCreditsYardIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/creditsyard/update-creditsyard-integration";
import {
  disconnectCustomReturnIntegration,
  getCustomReturnIntegration,
  setCustomReturnIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/custom-return-integration";
import {
  disconnectDeposcoIntegration,
  getDeposcoIntegration,
  setDeposcoIntegration,
  updateDeposcoIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/deposco";
import {
  disconnectFlexportIntegration,
  getFlexportIntegration,
  putFlexportIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/flexport";
import {
  disconnectInmarIntegration,
  getInmarIntegration,
  setInmarIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/inmar";
import {
  disconnectKlaviyoIntegration,
  getKlaviyoIntegration,
  setKlaviyoIntegration,
  updateKlaviyoIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/klaviyo";
import {
  disconnectLoopIntegration,
  getLoopIntegration,
  setLoopIntegration,
  updateLoopIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/loop";
import {
  disconnectLoopzIntegration,
  getLoopzIntegration,
  setLoopzIntegration,
  testLoopzConnection,
  updateLoopzIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/loopz";
import {
  disconnectPurpleDotIntegration,
  getPurpleDotIntegration,
  setPurpleDotIntegration,
  updatePurpleDotIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/purple-dot";
import {
  disconnectReturnBearIntegration,
  getReturnBearIntegration,
  setReturnBearIntegration,
  updateReturnBearIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/returnbear";
import {
  disconnectRiseAiIntegration,
  getRiseAiIntegration,
  initiateRiseAiOAuth,
  setRiseAiIntegration,
  updateRiseAiIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/rise-ai";
import {
  disconnectSekoIntegration,
  getSekoIntegration,
  setSekoIntegration,
  updateSekoIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/seko";
import {
  disconnectShipedgeIntegration,
  getShipedgeIntegration,
  putShipedgeIntegration,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/shipedge";
import {
  disconnectShipHeroIntegration,
  getShipHeroIntegration,
  getShipHeroProductBins,
  putShipheroIntegration,
  shipHeroInventoryAdd,
  validateShipHeroLocation,
} from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/shiphero";
import { getExchangeRates } from "@redotech/redo-model/money/get-exchange-rates";
import { submitWarrantyRegistrationSchema as submitWarrantyRegistration } from "@redotech/redo-model/warranties/submit-warranty-registration-schema";
import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { createRmaForReturn } from "../returns-rpc/schema/create-rma-for-return";
import { getValidReturnTrackingTriggers } from "../returns-rpc/schema/get-valid-return-tracking-triggers";
import { getWorkflowStatus } from "../returns-rpc/schema/get-workflow-status";
import { sendEmailFromTemplate } from "../returns-rpc/schema/send-email-from-template";
import { triggerEmailFlowPreview } from "../returns-rpc/schema/trigger-email-flow-preview";
import { getAddressFromSuggestion } from "./schema/address-autofill/get-address-from-suggestion";
import { getAutocompleteSuggestions } from "./schema/address-autofill/get-autocomplete-suggestions";
import { createAddress } from "./schema/addresses/create-address";
import { deleteAddress } from "./schema/addresses/delete-address";
import { getAddressCollections } from "./schema/addresses/get-address-collections";
import { getAddresses } from "./schema/addresses/get-addresses";
import { getAddressesByIds } from "./schema/addresses/get-addresses-by-ids";
import { getOrCreateExternalAddress } from "./schema/addresses/get-or-create-external-address";
import { updateAddress } from "./schema/addresses/update-address";
import { validateInternationalAddresses } from "./schema/addresses/validate-international-addresses";
import { batchUpdateRuleOrder } from "./schema/advanced-flows/batch-update-rule-order";
import { createAdvancedFlow } from "./schema/advanced-flows/create-advanced-flow";
import { createAdvancedFlowFromDefault } from "./schema/advanced-flows/create-advanced-flow-from-default";
import { deleteAdvancedFlow } from "./schema/advanced-flows/delete-advanced-flow";
import { getAdvancedFlowById } from "./schema/advanced-flows/get-advanced-flow-by-id";
import { getAdvancedFlowCount } from "./schema/advanced-flows/get-advanced-flow-count";
import { getAdvancedFlows } from "./schema/advanced-flows/get-advanced-flows";
import { getAdvancedFlowsByVersionGroupId } from "./schema/advanced-flows/get-advanced-flows-by-id";
import { getProcessingFlowEditorState } from "./schema/advanced-flows/get-processing-flow-editor-state";
import { getRulesByTrigger } from "./schema/advanced-flows/get-rules-by-trigger";
import { publishProcessingFlowRevision } from "./schema/advanced-flows/publish-processing-flow-revision";
import { saveProcessingFlowDraft } from "./schema/advanced-flows/save-processing-flow-draft";
import { updateAdvancedFlow } from "./schema/advanced-flows/update-advanced-flow";
import { addAeoPrompts } from "./schema/aeo/add-aeo-prompts";
import { archiveAeoPrompts } from "./schema/aeo/archive-aeo-prompts";
import { bulkAddTopicsToPrompts } from "./schema/aeo/bulk-add-topics-to-prompts";
import { bulkRemoveTopicsFromPrompts } from "./schema/aeo/bulk-remove-topics-from-prompts";
import { createAeoPromptTopic } from "./schema/aeo/create-aeo-prompt-topic";
import { deleteAeoPromptTopic } from "./schema/aeo/delete-aeo-prompt-topic";
import { generateAeoPrompts } from "./schema/aeo/generate-aeo-prompts";
import { getAeoDashboardCitations } from "./schema/aeo/get-aeo-dashboard-citations";
import { getAeoDashboardFilterOptions } from "./schema/aeo/get-aeo-dashboard-filter-options";
import { getAeoDashboardShareOfVoice } from "./schema/aeo/get-aeo-dashboard-share-of-voice";
import { getAeoDashboardTopicPrompts } from "./schema/aeo/get-aeo-dashboard-topic-prompts";
import { getAeoDashboardTopics } from "./schema/aeo/get-aeo-dashboard-topics";
import { getAeoDashboardVisibility } from "./schema/aeo/get-aeo-dashboard-visibility";
import { getAeoOnboardingProgress } from "./schema/aeo/get-aeo-onboarding-progress";
import { getAeoPromptDetails } from "./schema/aeo/get-aeo-prompt-details";
import { getAeoPromptResponseDetail } from "./schema/aeo/get-aeo-prompt-response-detail";
import { getAeoPromptResponseSourceCounts } from "./schema/aeo/get-aeo-prompt-response-source-counts";
import { getAeoPromptResponses } from "./schema/aeo/get-aeo-prompt-responses";
import { getAeoPromptSummary } from "./schema/aeo/get-aeo-prompt-summary";
import { getAeoPromptTopics } from "./schema/aeo/get-aeo-prompt-topics";
import { getAeoPrompts } from "./schema/aeo/get-aeo-prompts";
import { getBrandCompetitors } from "./schema/aeo/get-brand-competitors";
import { getBrandIdentityGuide } from "./schema/aeo/get-brand-identity-guide";
import { getBrandVisibilityOverTime } from "./schema/aeo/get-brand-visibility-over-time";
import { getCompetitorComparison } from "./schema/aeo/get-competitor-comparison";
import { getCurrentAeoInvoice } from "./schema/aeo/get-current-aeo-invoice";
import { getDashboardMetrics } from "./schema/aeo/get-dashboard-metrics";
import { getFinalizedAeoInvoices } from "./schema/aeo/get-finalized-aeo-invoices";
import { getModelPerformance } from "./schema/aeo/get-model-performance";
import { getSources } from "./schema/aeo/get-sources";
import { dismissAeoRecommendation } from "./schema/aeo/recommendations/dismiss-aeo-recommendation";
import { getAeoRecommendations } from "./schema/aeo/recommendations/get-aeo-recommendations";
import { restoreAeoRecommendation } from "./schema/aeo/recommendations/restore-aeo-recommendation";
import { updateAeoRecommendationFeedback } from "./schema/aeo/recommendations/update-aeo-recommendation-feedback";
import { setAeoPromptTopics } from "./schema/aeo/set-aeo-prompt-topics";
import { unarchiveAeoPrompts } from "./schema/aeo/unarchive-aeo-prompts";
import { updateAeoPromptBranded } from "./schema/aeo/update-aeo-prompt-branded";
import { updateAeoPromptTopic } from "./schema/aeo/update-aeo-prompt-topic";
import { confirmAeoAssistantTool } from "./schema/agents/aeo-assistant/confirm-aeo-assistant-tool";
import { getAeoAssistantThreadMessages } from "./schema/agents/aeo-assistant/get-aeo-assistant-thread-messages";
import { listAeoAssistantThreads } from "./schema/agents/aeo-assistant/list-aeo-assistant-threads";
import { respondToAeoAssistantTool } from "./schema/agents/aeo-assistant/respond-to-aeo-assistant-tool";
import { saveAeoAssistantThread } from "./schema/agents/aeo-assistant/save-aeo-assistant-thread";
import { streamAeoAssistant } from "./schema/agents/aeo-assistant/stream-aeo-assistant";
import { getAskRedoEmergencyMode } from "./schema/agents/ask-redo/get-ask-redo-emergency-mode";
import {
  getAskRedoThread,
  getAskRedoThreads,
} from "./schema/agents/ask-redo/get-ask-redo-threads";
import { streamAskRedo } from "./schema/agents/ask-redo/stream-ask-redo";
import { queryDom } from "./schema/agents/dom-agent/query-dom";
import {
  checkActiveEscalation,
  createEscalation,
  getEscalation,
  getEscalationMessages,
  markEscalationRead,
  sendEscalationMessage,
  shouldShowEscalationCsat,
  submitEscalationCsat,
  watchEscalationEvents,
} from "./schema/agents/merchant-support-agent/escalation";
import {
  getMerchantSupportAgentThread,
  getMerchantSupportAgentThreads,
  messageMerchantSupportAgent,
} from "./schema/agents/merchant-support-agent/message-merchant-support-agent";
import { streamMerchantSupportAgent } from "./schema/agents/merchant-support-agent/stream-merchant-support-agent";
import { provideAiFeedback } from "./schema/agents/provide-ai-feedback";
import { redoAi } from "./schema/agents/redo-ai";
import { generateAiAnalyticsSummary } from "./schema/ai-summary/generate-ai-analytics-summary";
import { getAiAnalyticsSummary } from "./schema/ai-summary/get-ai-analytics-summary";
import { getAiToneAndVoiceSettings } from "./schema/ai-tone-and-voice/get-ai-tone-and-voice-settings";
import { initializeAiToneAndVoice } from "./schema/ai-tone-and-voice/initialize-ai-tone-and-voice";
import { updateAiToneAndVoiceSettings } from "./schema/ai-tone-and-voice/update-ai-tone-and-voice-settings";
import { get3plDashboardMetrics } from "./schema/analytics/get-3pl-dashboard-metrics";
import { get3plLeaderboard } from "./schema/analytics/get-3pl-leaderboard";
import { getAiExchangeAgentAnalytics } from "./schema/analytics/get-ai-exchange-agent-analytics";
import { getClaimAttachmentRateSeriesData } from "./schema/analytics/get-claim-attachment-rate-series-data";
import { getClaimsAnalyticsStatistics } from "./schema/analytics/get-claims-analytics-statistics";
import { getOperationsNewTotals } from "./schema/analytics/get-operations-new-totals";
import { getOrderSourceNames } from "./schema/analytics/get-order-source-names";
import { getPortalEvents } from "./schema/analytics/get-portal-events";
import { getPortalOptimizationState } from "./schema/analytics/get-portal-optimization-state";
import { getProductBenchmark } from "./schema/analytics/get-product-benchmark";
import { getProductTitles } from "./schema/analytics/get-product-titles";
import { getReturnAnalyticsByProduct } from "./schema/analytics/get-return-analytics-by-product";
import { getReturnAnalyticsByVariant } from "./schema/analytics/get-return-analytics-by-variant";
import { getReturnAnalyticsSeriesData } from "./schema/analytics/get-return-analytics-series-data";
import { getReturnAnalyticsStatistics } from "./schema/analytics/get-return-analytics-statistics";
import { getReturnOperationsKeyStats } from "./schema/analytics/get-return-operations-key-stats";
import { getTags } from "./schema/analytics/get-tags";
import { getTryFirstAnalytics } from "./schema/analytics/get-try-first-analytics";
import { getVendorNames } from "./schema/analytics/get-vendor-names";
import {
  createReport,
  deleteCustomAnalyticsReport,
  deleteReport,
  getCustomAnalyticsReport,
  getCustomAnalyticsReportFilterOptions,
  getCustomAnalyticsReportRows,
  getReport,
  getReports,
  listCustomAnalyticsReportRevisions,
  listCustomAnalyticsReports,
  regenerateCustomAnalyticsReport,
  restoreCustomAnalyticsReportRevision,
  streamCustomAnalyticsReportData,
  streamOrderedLineItemsReportData,
  streamPurchasedExtendedWarrantyReportData,
  streamReturnedLineItemsReportData,
  streamReturnsReportData,
  streamWarrantyCustomersReportData,
  updateCustomAnalyticsReportTitle,
  updateReport,
} from "./schema/analytics/reports";
import { createApiToken } from "./schema/api-tokens/create-api-token";
import { listApiTokens } from "./schema/api-tokens/list-api-tokens";
import { revokeApiToken } from "./schema/api-tokens/revoke-api-token";
import { updateApiToken } from "./schema/api-tokens/update-api-token";
import { addAssessmentToReturn } from "./schema/assessments/add-assessment-to-return";
import { completeAssessmentOnReturn } from "./schema/assessments/complete-assessment-on-return";
import { createAssessment } from "./schema/assessments/create-assessment";
import { createGroup } from "./schema/assessments/create-group";
import { deleteAssessment } from "./schema/assessments/delete-assessment";
import { deleteGroup } from "./schema/assessments/delete-group";
import { getAssessmentDefinition } from "./schema/assessments/get-assessment-definition";
import { getAssessmentGroupList } from "./schema/assessments/get-assessment-group-list";
import { getAssessmentList } from "./schema/assessments/get-assessment-list";
import { getReturnProductAssessments } from "./schema/assessments/get-return-product-assessments";
import { removeAssessmentFromReturn } from "./schema/assessments/remove-assessment-from-return";
import { updateAssessment } from "./schema/assessments/update-assessment";
import { updateGroup } from "./schema/assessments/update-group";
import { updateProductAssessmentAssignee } from "./schema/assessments/update-product-assessment-assignee";
import { createStripeConnectedAccount } from "./schema/billing/create-stripe-connected-account";
import { deletePaymentMethod } from "./schema/billing/delete-payment-method";
import { getPaymentMethodStatus } from "./schema/billing/get-payment-method-status";
import { getStripeConnectedAccount } from "./schema/billing/get-stripe-connected-account";
import { onboardStripeConnectedAccount } from "./schema/billing/onboard-stripe-connected-account";
import { triggerManualPayout } from "./schema/billing/trigger-manual-payout";
import { generateContactCard } from "./schema/brand-kit/generate-contact-card";
import { processFontFiles } from "./schema/brand-kit/process-font-files";
import { updateBrandKit } from "./schema/brand-kit/update-brand-kit";
import { getBrandSummary } from "./schema/brand-summary/get-brand-summary";
import { updateBrandSummary } from "./schema/brand-summary/update-brand-summary";
import { calculateNewOrderValue } from "./schema/calculate-new-order-value";
import { cancelOrder } from "./schema/cancel-order";
import { authorizeUspsCarrierAccount } from "./schema/carrier-accounts/authorize-usps-carrier-account";
import { createCarrierAccount } from "./schema/carrier-accounts/create-carrier-account";
import { createDirectFedexCarrierAccount } from "./schema/carrier-accounts/create-direct-fedex-carrier-account";
import { deleteCarrierAccount } from "./schema/carrier-accounts/delete-carrier-account";
import { easypostFedexMfaAddressValidation } from "./schema/carrier-accounts/easypost-fedex-mfa-address-validation";
import { easypostFedexMfaGeneratePin } from "./schema/carrier-accounts/easypost-fedex-mfa-generate-pin";
import { easypostFedexMfaValidateInvoice } from "./schema/carrier-accounts/easypost-fedex-mfa-validate-invoice";
import { easypostFedexMfaValidatePin } from "./schema/carrier-accounts/easypost-fedex-mfa-validate-pin";
import { generateFedexPin } from "./schema/carrier-accounts/generate-fedex-pin";
import { getCarrierAccounts } from "./schema/carrier-accounts/get-carrier-accounts";
import { parseFedexInvoicePdf } from "./schema/carrier-accounts/parse-fedex-invoice-pdf";
import { submitFedexMfaBackup } from "./schema/carrier-accounts/submit-fedex-mfa-backup";
import { submitFedexMfaData } from "./schema/carrier-accounts/submit-fedex-mfa-data";
import { unverifyUspsContractRates } from "./schema/carrier-accounts/unverify-usps-contract-rates";
import { verifyUspsContractRatesLinked } from "./schema/carrier-accounts/verify-usps-contract-rates-linked";
import { editCartOptimizationSettings } from "./schema/cart-optimization/edit-cart-optimization-settings";
import { checkOrdersReturnability } from "./schema/check-orders-returnability";
import { fastTrackClaim } from "./schema/claims/fast-track-claim";
import { getCollections } from "./schema/collections/get-collections";
import { getConciergePhoneReadiness } from "./schema/concierge/get-concierge-phone-readiness";
import { provisionConciergePhoneNumber } from "./schema/concierge/provision-concierge-phone-number";
import { disableContextual } from "./schema/contextual/disable-contextual";
import { enableContextual } from "./schema/contextual/enable-contextual";
import { getContextualSettings } from "./schema/contextual/get-contextual-settings";
import { createOrderComment } from "./schema/create-order-comment";
import { disconnectRivoIntegration } from "./schema/customer-accounts/rivo/disconnect-rivo-integration";
import { getRivoIntegration } from "./schema/customer-accounts/rivo/get-rivo-integration";
import { setRivoIntegration } from "./schema/customer-accounts/rivo/set-rivo-integration";
import { getNativeAccountsSettings } from "./schema/customer-accounts/storefront-display-settings/get-native-accounts-settings";
import { updateNativeAccountsSettings } from "./schema/customer-accounts/storefront-display-settings/update-native-accounts-settings";
import { updateAllCustomerWidgetSettings } from "./schema/customer-widget/update-all-customer-widget-settings";
import { updateCustomerWidgetSettings } from "./schema/customer-widget/update-customer-widget-settings";
import { adjustLoyaltyPoints } from "./schema/customer/adjust-loyalty-points";
import { createCustomerAuthToken } from "./schema/customer/create-customer-auth-token";
import { getCustomer } from "./schema/customer/get-customer";
import { getCustomerByEmail } from "./schema/customer/get-customer-by-email";
import { getCustomerTags } from "./schema/customer/get-customer-tags";
import { getOrCreateCustomerFromPhoneNumber } from "./schema/customer/get-or-create-customer-from-phone-number";
import { connectStripeIntegration } from "./schema/disputes/connect-stripe-integration";
import { disconnectGorgiasIntegration } from "./schema/disputes/disconnect-gorgias-integration";
import { disconnectPayPalIntegration } from "./schema/disputes/disconnect-paypal-integration";
import { disconnectStripeIntegration } from "./schema/disputes/disconnect-stripe-integration";
import { enableDisputes } from "./schema/disputes/enable-disputes";
import { enableDisputesBilling } from "./schema/disputes/enable-disputes-billing";
import { generateAllEvidence } from "./schema/disputes/generate-all-evidence";
import { getDispute } from "./schema/disputes/get-dispute";
import { getDisputeDashboardStats } from "./schema/disputes/get-dispute-dashboard-stats";
import { getDisputeGorgiasTickets } from "./schema/disputes/get-dispute-gorgias-tickets";
import { getDisputes } from "./schema/disputes/get-disputes";
import { getGorgiasConnectionStatus } from "./schema/disputes/get-gorgias-connection-status";
import { getPayPalAuthUrl } from "./schema/disputes/get-paypal-auth-url";
import { getPayPalConnectionStatus } from "./schema/disputes/get-paypal-connection-status";
import { getReclaimAccessDefaults } from "./schema/disputes/get-reclaim-access-defaults";
import { getShopPolicies } from "./schema/disputes/get-shop-policies";
import { getShopifyPermissionsUpdateUrl } from "./schema/disputes/get-shopify-permissions-update-url";
import { getStripeConnectionStatus } from "./schema/disputes/get-stripe-connection-status";
import { redeemReclaimPartnerCode } from "./schema/disputes/redeem-reclaim-partner-code";
import { submitDisputeEvidence } from "./schema/disputes/submit-dispute-evidence";
import { toggleDisputeAutoEvidence } from "./schema/disputes/toggle-dispute-auto-evidence";
import { updateDisputeEvidence } from "./schema/disputes/update-dispute-evidence";
import { updateShopPolicy } from "./schema/disputes/update-shop-policy";
import { validateReclaimPartnerCode } from "./schema/disputes/validate-reclaim-partner-code";
import { createEmailTemplateFromDefault } from "./schema/email-templates/create-email-template-from-default";
import { createExchangeAgentGuidance } from "./schema/exchange-agent-guidance/create-exchange-agent-guidance";
import { deleteExchangeAgentGuidance } from "./schema/exchange-agent-guidance/delete-exchange-agent-guidance";
import { listExchangeAgentGuidance } from "./schema/exchange-agent-guidance/list-exchange-agent-guidance";
import { renameExchangeAgentGuidance } from "./schema/exchange-agent-guidance/rename-exchange-agent-guidance";
import { updateExchangeAgentGuidance } from "./schema/exchange-agent-guidance/update-exchange-agent-guidance";
import { getExtensionArtifact } from "./schema/extensions/get-extension-artifact";
import { getExtensionContractTypes } from "./schema/extensions/get-extension-contract-types";
import { uploadExtensionArtifact } from "./schema/extensions/upload-extension-artifact";
import { createArticle } from "./schema/faq/create-article";
import { createCollection } from "./schema/faq/create-collection";
import { createFaqPage } from "./schema/faq/create-faq-page";
import { deleteArticle } from "./schema/faq/delete-article";
import { deleteCollection } from "./schema/faq/delete-collection";
import { deleteFaqPage } from "./schema/faq/delete-faq-page";
import { getFaq } from "./schema/faq/get-faq";
import { getFaqArticles } from "./schema/faq/get-faq-articles";
import { getFaqCollections } from "./schema/faq/get-faq-collections";
import { getFaqPages } from "./schema/faq/get-faq-pages";
import { getFaqTheme } from "./schema/faq/get-faq-theme";
import { updateArticle } from "./schema/faq/update-article";
import { updateCollection } from "./schema/faq/update-collection";
import { updateFaqPage } from "./schema/faq/update-faq-page";
import { updateTheme } from "./schema/faq/update-theme";
import { findPreviousReturnShippingRefunds } from "./schema/find-previous-return-shipping-refunds";
import { createFreightDeliveryAccessorialPreset } from "./schema/freight/create-freight-delivery-accessorial-preset";
import { createFreightHandlingUnit } from "./schema/freight/create-freight-handling-unit";
import { createFreightPickupAccessorialPreset } from "./schema/freight/create-freight-pickup-accessorial-preset";
import { createFreightPickupWindow } from "./schema/freight/create-freight-pickup-window";
import { deleteFreightDeliveryAccessorialPreset } from "./schema/freight/delete-freight-delivery-accessorial-preset";
import { deleteFreightHandlingUnit } from "./schema/freight/delete-freight-handling-unit";
import { deleteFreightPickupAccessorialPreset } from "./schema/freight/delete-freight-pickup-accessorial-preset";
import { deleteFreightPickupWindow } from "./schema/freight/delete-freight-pickup-window";
import { generateFreightQuotes } from "./schema/freight/generate-freight-quotes";
import { getFreightDeliveryAccessorialPresets } from "./schema/freight/get-freight-delivery-accessorial-presets";
import { getFreightHandlingUnits } from "./schema/freight/get-freight-handling-units";
import { getFreightPickupAccessorialPresets } from "./schema/freight/get-freight-pickup-accessorial-presets";
import { getFreightPickupWindows } from "./schema/freight/get-freight-pickup-windows";
import { purchaseFreightBooking } from "./schema/freight/purchase-freight-booking";
import { setDefaultFreightDeliveryAccessorialPreset } from "./schema/freight/set-default-freight-delivery-accessorial-preset";
import { setDefaultFreightHandlingUnit } from "./schema/freight/set-default-freight-handling-unit";
import { setDefaultFreightPickupAccessorialPreset } from "./schema/freight/set-default-freight-pickup-accessorial-preset";
import { setDefaultFreightPickupWindow } from "./schema/freight/set-default-freight-pickup-window";
import { generateFlowAgentResponse } from "./schema/generate-flow-agent-response";
import { fireMerchantEmailTriggerRpc } from "./schema/merchant-email/fire-merchant-email-trigger";
import { createCheckoutSession } from "./schema/redo-supplies/create-checkout-session";
import { getCheckoutSession } from "./schema/redo-supplies/get-checkout-session";
import { getRedoSuppliesOrder } from "./schema/redo-supplies/get-redo-supplies-order";
import { getRedoSuppliesOrderFulfillmentGroups } from "./schema/redo-supplies/get-redo-supplies-order-fulfillment-groups";
import {
  getRedoSuppliesOrders,
  getRedoSuppliesOrdersCount,
} from "./schema/redo-supplies/get-redo-supplies-orders";
import { getRedoSuppliesProductDetail } from "./schema/redo-supplies/get-redo-supplies-product-detail";
import { getRedoSuppliesProducts } from "./schema/redo-supplies/get-redo-supplies-products";
import {
  getSuppliesInventoryConfigs,
  getSuppliesInventoryConfigsCount,
} from "./schema/redo-supplies/get-supplies-inventory-configs";
import { handleRedoSuppliesCheckoutCompleted } from "./schema/redo-supplies/handle-redo-supplies-checkout-completed";
import {
  getRedoCart,
  setCartDestinationLocation,
  upsertRedoCartItems,
} from "./schema/redo-supplies/redo-cart";
import { updateSuppliesInventoryConfig } from "./schema/redo-supplies/update-supplies-inventory-config";
import { createWorkOrderFlow } from "./schema/work-order-flows/create-work-order-flow";
import { deleteWorkOrderFlow } from "./schema/work-order-flows/delete-work-order-flow";
import { getWorkOrderFlowById } from "./schema/work-order-flows/get-work-order-flow-by-id";
import { getWorkOrderFlows } from "./schema/work-order-flows/get-work-order-flows";
import { updateWorkOrderFlowSteps } from "./schema/work-order-flows/update-work-order-flow-steps";
import { updateWorkOrderFlows } from "./schema/work-order-flows/update-work-order-flows";

import { authorizeFaireIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/authorize-faire-integration";
import { getBigcommerceIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/bigcommerce/get-bigcommerce-integration";
import { setBigcommerceExchangeOrderStatus } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/bigcommerce/set-bigcommerce-exchange-order-status";
import { setBigcommerceRefundMethod } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/bigcommerce/set-bigcommerce-refund-method";
import { setBigcommerceStoreCreditType } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/bigcommerce/set-bigcommerce-store-credit-type";
import { disconnectBlueCherryIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/blue-cherry/disconnect-blue-cherry-integration";
import { getBlueCherryIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/blue-cherry/get-blue-cherry-integration";
import { setBlueCherryIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/blue-cherry/set-blue-cherry-integration";
import { disconnectCloudXIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/cloudx/disconnect-cloudx-integration";
import { getCloudXIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/cloudx/get-cloudx-integration";
import { postCloudXIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/cloudx/post-cloudx-integration";
import { createCommentsoldIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/commentsold/create-commentsold-integration";
import { deleteCommentsoldIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/commentsold/delete-commentsold-integration";
import { enableOmsOnCommentsoldIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/commentsold/enable-oms-on-commentsold-integration";
import { getCommentsoldIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/commentsold/get-commentsold-integration";
import { getCommentsoldOAuthUrl } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/commentsold/get-commentsold-oauth-url";
import { updateCommentsoldIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/commentsold/update-commentsold-integration";
import { createCin7CoreIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/create-cin7-core-integration";
import { createCin7OmniIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/create-cin7-omni-integration";
import { createOmsApparelMagicIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/create-oms-apparel-magic-integration";
import { createTiktokIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/create-tiktok-integration";
import { deleteEcwidIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/delete-ecwid-integration";
import { deleteShipmonkIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/delete-shipmonk-integration";
import { disconnectFaireIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/disconnect-faire-integration";
import { disconnectOmsTiktokIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/disconnect-oms-tiktok-integration";
import { disconnectReturnsTiktokIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/disconnect-returns-tiktok-integration";
import { disconnectWalmartIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/disconnect-walmart-integration";
import { doesEbayIntegrationExist } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/does-ebay-integration-exist";
import { getDropoffTracking } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/dropoff/get-dropoff-tracking";
import { exchangeTrackstarAuthCode } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/exchange-trackstar-auth-code";
import { getAmazonAuthUrl } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-amazon-auth-url";
import { getAmazonIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-amazon-integration";
import { getCin7CoreIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-cin7-core-integration";
import { getCin7OmniIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-cin7-omni-integration";
import { getEbayAuthorizationUrl } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-ebay-authorization-url";
import { getEcwidIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-ecwid-integration";
import { getEnabledFulfillmentProviders } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-enabled-fulfillment-providers";
import { getFaireIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-faire-integration";
import { getGmailRecentMessages } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-gmail-recent-messages";
import { getGmailThread } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-gmail-thread";
import { getLegacySignedOAuthState } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-legacy-signed-oauth-state";
import { getMarketingEcommerceProviders } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-marketing-ecommerce-providers";
import { getOmsApparelMagicIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-oms-apparel-magic-integration";
import { getOmsTiktokIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-oms-tiktok-integration";
import { getReturnsTiktokIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-returns-tiktok-integration";
import { getShipmonkIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-shipmonk-integration";
import { getTeamEcommerceProviders } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-team-ecommerce-providers";
import { getTiktokAuthorizationExpiration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-tiktok-authorization-expiration";
import { getTrackstarConnections } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-trackstar-connections";
import { getTrackstarLinkToken } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-trackstar-link-token";
import { getWalmartIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/get-walmart-integration";
import { disconnectGlobalEIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/globale/disconnect-globale-integration";
import { getGlobalEIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/globale/get-globale-integration";
import { setGlobalEIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/globale/set-globale-integration";
import { disconnectIDFShippingIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/idf-shipping/disconnect-idf-shipping-integration";
import { getIDFShippingIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/idf-shipping/get-idf-shipping-integration";
import { setIDFShippingIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/idf-shipping/set-idf-shipping-integration";
import { disconnectKatanaIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/katana/disconnect-katana-integration";
import { getKatanaIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/katana/get-katana-integration";
import { setKatanaIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/katana/set-katana-integration";
import { createLandmarkGlobalIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/landmark-global/create-landmark-global-integration";
import { getLandmarkGlobalIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/landmark-global/get-landmark-global-integration";
import { disconnectLuminousIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/luminous/disconnect-luminous-integration";
import { getLuminousIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/luminous/get-luminous-integration";
import { setLuminousIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/luminous/set-luminous-integration";
import { updateLuminousIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/luminous/update-luminous-integration";
import { disconnectMintsoftIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/mintsoft/disconnect-mintsoft-integration";
import { getMintsoftIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/mintsoft/get-mintsoft-integration";
import { getReturnReasons } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/mintsoft/get-return-reasons";
import { setMintsoftIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/mintsoft/set-mintsoft-integration";
import { deleteNetSuiteIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/netsuite/delete-netsuite-integration";
import { getNetSuiteIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/netsuite/get-netsuite-integration";
import { getNetSuiteOAuthUrl } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/netsuite/get-netsuite-oauth-url";
import { retryItemReceiptEvent } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/netsuite/retry-item-receipt-event";
import { testNetSuiteReturnAuthorization } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/netsuite/test-netsuite-return-authorization";
import { upsertNetSuiteIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/netsuite/upsert-netsuite-integration";
import { disconnectOkendoIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/okendo/disconnect-okendo-integration";
import { getOkendoIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/okendo/get-okendo-integration";
import { setOkendoIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/okendo/set-okendo-integration";
import { getBrightpearlOrderStatuses } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/oms-brightpearl/get-brightpearl-order-statuses";
import { updateBrightpearlOmsSettings } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/oms-brightpearl/update-brightpearl-oms-settings";
import { createOmsNetsuiteIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/oms-netsuite/create-oms-netsuite-integration";
import { getOmsNetsuiteIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/oms-netsuite/get-oms-netsuite-integration";
import { updateOmsNetsuiteIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/oms-netsuite/update-oms-netsuite-integration";
import { connectTripleWhaleOmsIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/oms-triple-whale/connect-triple-whale-oms-integration";
import { getTripleWhaleOmsIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/oms-triple-whale/get-triple-whale-oms-integration";
import { updateTripleWhaleOmsSettings } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/oms-triple-whale/update-triple-whale-oms-settings";
import { createParentEasypostIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/parent-easypost/create-parent-easypost-integration";
import { deleteParentEasypostIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/parent-easypost/delete-parent-easypost-integration";
import { getParentEasypostIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/parent-easypost/get-parent-easypost-integration";
import { updateParentEasypostIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/parent-easypost/update-parent-easypost-integration";
import { putEcwidIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/put-ecwid-integration";
import { putShipmonkIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/put-shipmonk-integration";
import { reconnectFaireIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/reconnect-faire-integration";
import { disconnectRefundidIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/refundid/disconnect-refundid-integration";
import { getRefundidIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/refundid/get-refundid-integration";
import { setRefundidIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/refundid/set-refundid-integration";
import { resendExternalReturnShippingProviderLabel } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/resend-external-return-shipping-provider-label";
import { getReturnBearExceptions } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/returnbear/get-return-bear-exceptions";
import { getReturnBearTrackingEvents } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/returnbear/get-returnbear-tracking-events";
import { resolveReturnBearException } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/returnbear/resolve-return-bear-exception";
import { updateBrightpearlReturnsSettings } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/returns-brightpearl/update-brightpearl-returns-settings";
import { setReturnsTiktokIntegrationSettings } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/set-returns-tiktok-integration-settings";
import { getShopifyIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/shopify/get-shopify-integration";
import { setShopifyRefundMethod } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/shopify/set-shopify-refund-method";
import { disconnectTeamworkCommerceIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/teamwork-commerce/disconnect-teamwork-commerce-integration";
import { getTeamworkCommerceIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/teamwork-commerce/get-teamwork-commerce-integration";
import { setTeamworkCommerceIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/teamwork-commerce/set-teamwork-commerce-integration";
import { updateCin7CoreIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/update-cin7-core-integration";
import { updateCin7OmniIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/update-cin7-omni-integration";
import { updateOmsApparelMagicIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/update-oms-apparel-magic-integration";
import { updateTrackstarReturnConnectionSettings } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/update-trackstar-return-connection-settings";
import { createWayfairIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/wayfair/create-wayfair-integration";
import { disconnectWayfairIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/wayfair/disconnect-wayfair-integration";
import { getWayfairIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/wayfair/get-wayfair-integration";
import { createWooCommerceIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/woocommerce/create-woocommerce-integration";
import { getWooCommerceIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/woocommerce/get-woocommerce-integration";
import { testWooCommerceConnection } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/woocommerce/test-woocommerce-connection";
import { updateWooCommerceIntegration } from "@redotech/redo-merchant-integrations-rpc/schema/integrations/woocommerce/update-woocommerce-integration";
import { getAllIntegrationStatuses } from "@redotech/redo-merchant-integrations-rpc/schema/returns-rpc/get-all-integration-statuses";
import { getBatchTnplContractStatus } from "./schema/get-batch-tnpl-contract-status";
import { getBundlesData } from "./schema/get-bundles-data";
import { getCollectionInfoByIds } from "./schema/get-collections";
import { getCustomerAccountsMetricsForOverview } from "./schema/get-customer-accounts-metrics-for-overview";
import { getDraftReturn } from "./schema/get-draft-return";
import { getEmailTemplateNames } from "./schema/get-email-template-names";
import { getFirstReturnForOrder } from "./schema/get-first-return-for-order";
import { getImportInternationalCustomsCsvStatus } from "./schema/get-import-international-customs-csv-status";
import { getLabelRates } from "./schema/get-label-rates";
import { getManagedClaimStatus } from "./schema/get-managed-claim-status";
import { getOrder } from "./schema/get-order";
import { getOrderId } from "./schema/get-order-id";
import { getOrders } from "./schema/get-orders";
import { getOriginDiscounts } from "./schema/get-origin-discounts";
import { getRepairInvoiceDetails } from "./schema/get-repair-invoice-details";
import { getReturn } from "./schema/get-return";
import { getReturnLifecycle } from "./schema/get-return-lifecycle";
import { getReturnTotals } from "./schema/get-return-totals";
import { getReturnTotalsFeatureFlag } from "./schema/get-return-totals-feature-flag";
import { getReturnsCount } from "./schema/get-returns-count";
import { getReturnsInstantExchangeRecoveryHistory } from "./schema/get-returns-instant-exchange-recovery-history";
import { getReturnsPagination } from "./schema/get-returns-pagination";
import { getSaveForLaterStorefrontDisplaySettings } from "./schema/get-save-for-later-storefront-display-settings";
import { getTeamWebhooks } from "./schema/get-team-webhooks";
import { getTnplContractStatus } from "./schema/get-tnpl-contract-status";
import { getUploadBundlesStatus } from "./schema/get-upload-bundles-status";
import { getVariantById } from "./schema/get-variant-by-id";
import { getWarehouseForProduct } from "./schema/get-warehouse-for-product";
import { getWarrantyRegistration } from "./schema/get-warranty-registration";
import { getWarrantyRegistrations } from "./schema/get-warranty-registrations";
import { getWarrantyRegistrationsCount } from "./schema/get-warranty-registrations-count";
import { getWebhookEvents } from "./schema/get-webhook-events";
import { getGiftReceiptRequests } from "./schema/gift-receipt-requests/get-gift-receipt-requests";
import { updateGiftReceiptRequestStatus } from "./schema/gift-receipt-requests/update-gift-receipt-request-status";
import { getGlobalSearchResults } from "./schema/global-search/get-global-search-results";
import { importInternationalCustomsCsv } from "./schema/import-international-customs-csv";
import { getCurrentImsForecastingInvoice } from "./schema/ims/get-current-ims-forecasting-invoice";
import { getCurrentImsInvoice } from "./schema/ims/get-current-ims-invoice";
import { getFinalizedImsForecastingInvoices } from "./schema/ims/get-finalized-ims-forecasting-invoices";
import { getFinalizedImsInvoices } from "./schema/ims/get-finalized-ims-invoices";
import { getIndustryCategoryComparisonStats } from "./schema/industry-category/get-industry-category-comparison-stats";
import { getValidIndustryCategories } from "./schema/industry-category/get-valid-industry-categories";
import { getInmarBlindReturns } from "./schema/inmar-blind-returns/get-inmar-blind-returns";
import { updateInmarBlindReturnStatus } from "./schema/inmar-blind-returns/update-inmar-blind-return-status";
import { deleteMasonhubIntegration } from "./schema/integrations/delete-masonhub-integration";
import { deleteShipbobIntegration } from "./schema/integrations/delete-shipbob-integration";
import { getMasonhubIntegration } from "./schema/integrations/get-masonhub-integration";
import { getShipbobIntegrations } from "./schema/integrations/get-shipbob-integrations";
import { putMasonhubIntegration } from "./schema/integrations/put-masonhub-integration";
import { disconnectRyderIntegration } from "./schema/integrations/ryder/disconnect-ryder-integration";
import { getRyderIntegration } from "./schema/integrations/ryder/get-ryder-integration";
import { retryRyderWebhookSubscription } from "./schema/integrations/ryder/retry-ryder-webhook-subscription";
import { updateRyderIntegration } from "./schema/integrations/ryder/update-ryder-integration";
import { issueStoreCreditToCustomer } from "./schema/issue-store-credit-to-customer";
import { createOrUpdateLocalizationGroup } from "./schema/localization/create-localization-group";
import { deleteLocalizationGroup } from "./schema/localization/delete-localization-group";
import { getLocalizationGroups } from "./schema/localization/get-localization-groups";
import { getLocalizationTextOverrides } from "./schema/localization/get-localization-text-overrides";
import { saveLocalizationTextOverrides } from "./schema/localization/save-localization-text-overrides";
import { getMerchantRecommendedExchanges } from "./schema/merchant-recommended-exchanges/get-merchant-recommended-exchanges";
import { getProductsForExchangeGrouping } from "./schema/merchant-recommended-exchanges/get-products-for-exchange-grouping";
import { updateMerchantRecommendedExchanges } from "./schema/merchant-recommended-exchanges/update-merchant-recommended-exchanges";
import { getEditSourceCounts } from "./schema/order-edits/get-edit-source-counts";
import { getEditTypeCounts } from "./schema/order-edits/get-edit-type-counts";
import { getUpsellRevenue } from "./schema/order-edits/get-upsell-revenue";
import { searchOrderEdits } from "./schema/order-edits/search-order-edits";
import { searchOrderEditsCount } from "./schema/order-edits/search-order-edits-count";
import { getOrdersWithPickStatus } from "./schema/orders/get-orders-with-pick-status";
import { getTeamOrdersByEmail } from "./schema/orders/get-team-orders-by-email";
import { syncOrder } from "./schema/orders/sync-order";
import { syncOrderByProviderId } from "./schema/orders/sync-order-by-provider-id";
import { addOutboundFunds } from "./schema/outbound-labels/add-outbound-funds";
import { cancelPickup } from "./schema/outbound-labels/cancel-pickup";
import { createPickup } from "./schema/outbound-labels/create-ups-pickup";
import { acceptLabelsUpsell } from "./schema/outbound-labels/dismiss-upsell";
import { getPendingUpsPickups } from "./schema/outbound-labels/get-pending-ups-pickups";
import { requestRecurringPickup } from "./schema/outbound-labels/request-recurring-pickup";
import {
  searchPickups,
  searchPickupsCount,
} from "./schema/outbound-labels/search-pickups";
import { createPackingSlipTemplate } from "./schema/packing-slips/create-packing-slip-template";
import { deletePackingSlipTemplate } from "./schema/packing-slips/delete-packing-slip-template";
import { getPackingSlipTemplate } from "./schema/packing-slips/get-packing-slip-template";
import { getPackingSlipTemplatesByTeam } from "./schema/packing-slips/get-packing-slip-templates-by-team";
import { updatePackingSlipTemplate } from "./schema/packing-slips/update-packing-slip-template";
import { getPayoutInvoiceCsv } from "./schema/payouts/get-payout-invoice-csv";
import { getPayoutInvoicePdf } from "./schema/payouts/get-payout-invoice-pdf";
import { getPoEmailSettings } from "./schema/po-email-settings/get-po-email-settings";
import { sendTestPoEmail } from "./schema/po-email-settings/send-test-po-email";
import { updatePoEmailSettings } from "./schema/po-email-settings/update-po-email-settings";
import { getPortalCustomization } from "./schema/portal-customization/get-portal-customization";
import { updatePortalCustomization } from "./schema/portal-customization/update-portal-customization";
import { processReturn } from "./schema/process-return";
import { getProduct } from "./schema/products/get-product";
import { getProductVendors } from "./schema/products/get-product-vendors";
import { searchProductTags } from "./schema/products/search-product-tags";
import { searchProducts } from "./schema/products/search-products";
import { purchaseLabel } from "./schema/purchase-label";
import { getRateCalculatorRates } from "./schema/rate-calculator/get-rate-calculator-rates";
import { removeVariantExchangeItem } from "./schema/remove-variant-exchange-item";
import { resendEmail } from "./schema/resend-email";
import { resendGiftCard } from "./schema/resend-gift-card";
import { resendLabel } from "./schema/resend-label";
import { resetOrderFlow } from "./schema/reset-order-flow/reset-order-flow";
import { restockItemsForReturn } from "./schema/restock/restock-items-for-return";
import { setReturnItemDisposition } from "./schema/return-item-disposition/set-return-item-disposition";
import { getAiChats } from "./schema/return-page-details/get-ai-chats";
import { getAiReturnReasonsConversation } from "./schema/return-page-details/get-ai-return-reasons-conversation";
import { getProductVariantMetafields } from "./schema/return-page-details/get-product-variant-metafields";
import { getReturnItemBinLocation } from "./schema/return-page-details/get-return-item-bin";
import { getReturnOrderNotes } from "./schema/return-page-details/get-return-order-notes";
import { getReturnVerification } from "./schema/return-page-details/get-return-verification";
import { getReturnWmsEvents } from "./schema/return-page-details/get-return-wms-events";
import { getRivoCustomerLoyalty } from "./schema/return-page-details/get-rivo-customer-loyalty";
import { provideMessageFeedback } from "./schema/return-page-details/provide-message-feedback";
import { refundExchangeShipping } from "./schema/return-page-details/refund-exchange-shipping";
import { submitReturnShippingClaim } from "./schema/return-page-details/submit-return-shipping-claim";
import { attemptReturnPickupRefund } from "./schema/return-pickup/attempt-return-pickup-refund";
import { rescheduleReturnPickup } from "./schema/return-pickup/reschedule-return-pickup";
import { scheduleReturnPickup } from "./schema/return-pickup/schedule-return-pickup";
import { createReturnViewFolder } from "./schema/return-views/create-return-view-folder";
import { deleteReturnView } from "./schema/return-views/delete-return-view";
import { deleteReturnViewFolder } from "./schema/return-views/delete-return-view-folder";
import { getReturnViewNotificationCounts } from "./schema/return-views/get-return-view-notification-counts";
import { getReturnViewsAndFolders } from "./schema/return-views/get-return-views-and-folders";
import { saveReturnView } from "./schema/return-views/save-return-view";
import { saveReturnViewsAndFolders } from "./schema/return-views/save-return-views-and-folders";
import { updateReturnViewFolderName } from "./schema/return-views/update-return-view-folder";
import { addTagToReturn } from "./schema/returns/add-tag-to-return";
import {
  getCurrentReturnAiExchangeAgentInvoice,
  getFinalizedReturnAiExchangeAgentInvoices,
} from "./schema/returns/ai-exchange-agent-invoices";
import { changePendingLockStatus } from "./schema/returns/change-pending-lock-status";
import { dismissCreateShipmentFailure } from "./schema/returns/dismiss-create-shipment-failure";
import { dismissRmaCreationFailure } from "./schema/returns/dismiss-rma-creation-failure";
import { enableAiExchangeAgent } from "./schema/returns/enable-ai-exchange-agent";
import { getCurrentReturnsInvoice } from "./schema/returns/get-current-returns-invoice";
import { getFinalizedReturnsInvoices } from "./schema/returns/get-finalized-returns-invoices";
import { getFraudZipCodeStats } from "./schema/returns/get-fraud-zip-code-stats";
import { removeTagFromReturn } from "./schema/returns/remove-tag-from-return";
import { setMerchantFraudFeedback } from "./schema/returns/set-merchant-fraud-feedback";
import { updateProductReturn } from "./schema/returns/update-product-return";
import { updateReturnAdjustment } from "./schema/returns/update-return-adjustment";
import { updateReturnCustomerContact } from "./schema/returns/update-return-customer-contact";
import { updateReturnPermissions } from "./schema/returns/update-return-permissions";
import { getRedoSalesChannels } from "./schema/sales-channels/get-redo-sales-channels";
import { getSalesChannelOptions } from "./schema/sales-channels/get-sales-channel-options";
import { getUncoveredSalesChannelWarnings } from "./schema/sales-channels/get-uncovered-sales-channel-warnings";
import { setRedoSalesChannels } from "./schema/sales-channels/set-redo-sales-channels";
import { searchProductVariants } from "./schema/search-product-variants";
import { sendRepairInvoice } from "./schema/send-repair-invoice";
import { setTeamWebhooks } from "./schema/set-team-webhooks";
import { getCartValidationFunctionStatus } from "./schema/shopify/get-cart-validation-function-status";
import { getShopifyPlan } from "./schema/shopify/get-shopify-plan";
import { getProductIdToProductAsVariantProductIds } from "./schema/shopify/products-as-variants/get-product-id-to-pav-product-ids";
import { getProductsAsVariantsConfigurations } from "./schema/shopify/products-as-variants/get-products-as-variants-configurations";
import { syncProductsAsVariants } from "./schema/shopify/products-as-variants/sync-products-as-variants";
import { testProductsAsVariantsConfigurations } from "./schema/shopify/products-as-variants/test-products-as-variants-configurations";
import { updateProductsAsVariantsConfigurations } from "./schema/shopify/products-as-variants/update-products-as-variants-configurations";
import { refreshShopifyPlan } from "./schema/shopify/refresh-shopify-plan";
import { toggleCartValidationFunction } from "./schema/shopify/toggle-cart-validation-function";
import { speechToText } from "./schema/speech-to-text";
import { createSpotlight } from "./schema/spotlights/create-spotlight";
import { createSpotlightSplit } from "./schema/spotlights/create-spotlight-split";
import { deleteSpotlight } from "./schema/spotlights/delete-spotlight";
import { duplicateSpotlight } from "./schema/spotlights/duplicate-spotlight";
import { getSpotlight } from "./schema/spotlights/get-spotlight";
import { getSpotlightSplits } from "./schema/spotlights/get-spotlight-splits";
import { getSpotlights } from "./schema/spotlights/get-spotlights";
import { updateSpotlight } from "./schema/spotlights/update-spotlight";
import { updateSpotlightSplitStatus } from "./schema/spotlights/update-spotlight-split-status";
import { createCallAvailability } from "./schema/support/create-call-availability";
import {
  getCsatResponsesForConversation,
  getCsatResponsesForTeam,
  getCsatResponsesForTeamCount,
} from "./schema/support/csat";
import { deleteRecordingFromCallRecord } from "./schema/support/delete-recording-from-call-record";
import { generatePdfForInvoice } from "./schema/support/generate-pdf-for-invoice";
import { getCallRecordWithTranscript } from "./schema/support/get-call-record-with-transcript";
import { getConversationInsights } from "./schema/support/get-conversation-insights";
import { getConversationInsightsCount } from "./schema/support/get-conversation-insights-count";
import { getConversationTagsById } from "./schema/support/get-conversation-tags-by-ids";
import { getSupportAiPricing } from "./schema/support/get-support-ai-pricing";
import { getSupportBillingInvoices } from "./schema/support/get-support-billing-invoices";
import { getTeamCallAvailabilities } from "./schema/support/get-team-call-availabilities";
import { grantFreeTrialCredits } from "./schema/support/grant-free-trial-credits";
import { hasReachedConversationThreshold } from "./schema/support/has-reached-conversation-threshold";
import { manuallyConvertChatToEmail } from "./schema/support/manually-convert-chat-to-email";
import { getPhoneNumberForTeam } from "./schema/support/phone-number";
import { polishMessage } from "./schema/support/polish-message";
import { searchTelnyxPhoneNumbers } from "./schema/support/search-telnyx-phone-numbers";
import { setupPhoneNumber } from "./schema/support/setup-phone-number";
import { getTelnyxTelephonyToken } from "./schema/support/telnyx-telephony-token";
import { toggleCallBeingRecorded } from "./schema/support/toggle-call-being-recorded";
import { toggleCallOnHold } from "./schema/support/toggle-call-on-hold";
import { turnOnSupportDefaults } from "./schema/support/turn-on-support-defaults";
import { updateAiFeedbackOnMessage } from "./schema/support/update-ai-feedback-on-message";
import { updateSupportSettings } from "./schema/support/update-support-settings";
import { createTagGroup } from "./schema/tag-groups/create-tag-group";
import { deleteTagGroup } from "./schema/tag-groups/delete-tag-group";
import { getTagGroups } from "./schema/tag-groups/get-tag-groups";
import { updateTagGroup } from "./schema/tag-groups/update-tag-group";
import { deleteTag } from "./schema/tags/delete-tag";
import { editTag } from "./schema/tags/edit-tag";
import { getTagsByTagGroup } from "./schema/tags/get-tags-by-tag-group";
import { getTeamTags } from "./schema/tags/get-team-tags";
import { upsertTag } from "./schema/tags/upsert-tag";
import { getPickedSettings } from "./schema/team-settings/get-picked-settings";
import { updatePickedSettings } from "./schema/team-settings/update-picked-settings";
import { watchTeamEvents } from "./schema/team/watch-team-events";
import { createThirdPartyBillingAccount } from "./schema/third-party-billing-accounts/create-third-party-billing-account";
import { deleteThirdPartyBillingAccount } from "./schema/third-party-billing-accounts/delete-third-party-billing-account";
import { getThirdPartyBillingAccounts } from "./schema/third-party-billing-accounts/get-third-party-billing-accounts";
import { checkShopifySelector } from "./schema/try-first/check-shopify-selector";
import { editTryFirstPlan } from "./schema/try-first/edit-try-first-plan";
import { getTryFirstPlan } from "./schema/try-first/get-try-first-plan";
import { updateTryFirstWidgetSettings } from "./schema/try-first/update-try-first-widget-settings";
import { exportBillCsv } from "./schema/unified-billing/export-bill-csv";
import { generatePdfForBill } from "./schema/unified-billing/generate-pdf-for-bill";
import { getAccountBillingSettings } from "./schema/unified-billing/get-account-billing-settings";
import { getBillDetails } from "./schema/unified-billing/get-bill-details";
import { getBillingChargesAndTransactions } from "./schema/unified-billing/get-billing-charges-and-transactions";
import { getBills } from "./schema/unified-billing/get-bills";
import { updateNewOrderItems } from "./schema/update-new-order-items";
import { updatePosSettings } from "./schema/update-pos-settings";
import { updateRepairInvoice } from "./schema/update-repair-invoice";
import { updateReturnWithShippingRefund } from "./schema/update-return-with-shipping-refund";
import { updateReturnWithWaivedDraftFee } from "./schema/update-return-with-waived-draft-fee";
import { updateReturnWithWaivedShippingFee } from "./schema/update-return-with-waived-shipping-fee";
import { updateSaveForLaterStorefrontDisplaySettings } from "./schema/update-save-for-later-storefront-display-settings";
import { updateWarrantyRegistrationCustomItem } from "./schema/update-warranty-registration-custom-item";
import { updateWarrantyRegistrationProduct } from "./schema/update-warranty-registration-product";
import { uploadBundles } from "./schema/upload-bundles";
import { uploadSkuGroupingCsv } from "./schema/upload-sku-grouping-csv";
import { getUpsellPageAnalytics } from "./schema/upsell-page-analytics.ts/get-upsell-page-analytics";
import { getPostPurchaseAnalyticsByCheckoutToken } from "./schema/upsell-page-analytics/get-post-purchase-analytics-by-checkout-token";
import { getUpsellProductAnalytics } from "./schema/upsell-page-analytics/get-upsell-product-analytics";
import { createUpsellPage } from "./schema/upsell-page/create-upsell-page";
import { getUpsellPage } from "./schema/upsell-page/get-upsell-page";
import { updateUpsellPage } from "./schema/upsell-page/update-upsell-page";
import { getUserPin } from "./schema/users/get-user-pin";
import { getProductsForVariantExchangeGuidance } from "./schema/variant-exchange-guidance/get-products-for-variant-exchange-guidance";
import { getVariantExchangeGuidance } from "./schema/variant-exchange-guidance/get-variant-exchange-guidance";
import { updateVariantExchangeGuidance } from "./schema/variant-exchange-guidance/update-variant-exchange-guidance";
import { watchReturn } from "./schema/watch-return";
import { activateWebPixelSetting } from "./schema/web-pixel/activate-web-pixel-setting";
import { deactivateWebPixelSetting } from "./schema/web-pixel/deactivate-web-pixel-setting";
import { getCustomerYofiScores } from "./schema/yofi/get-yofi-scores";

const localizationRpcDefinitions = {
  getLocalizationGroups,
  createOrUpdateLocalizationGroup,
  deleteLocalizationGroup,
  getLocalizationTextOverrides,
  saveLocalizationTextOverrides,
} as const;

const returnAssessmentDefinitions = {
  createAssessment,
  getAssessmentDefinition,
  getAssessmentList,
  getAssessmentGroupList,
  getReturnProductAssessments,
  updateAssessment,
  deleteAssessment,
  createGroup,
  updateGroup,
  deleteGroup,
  addAssessmentToReturn,
  removeAssessmentFromReturn,
  completeAssessmentOnReturn,
  updateProductAssessmentAssignee,
};

const integrationRpcDefinitions = {
  getAllIntegrationStatuses,
  createCin7CoreIntegration,
  createCin7OmniIntegration,
  createTiktokIntegration,
  createOmsApparelMagicIntegration,
  updateOmsApparelMagicIntegration,
  doesEbayIntegrationExist,
  getCin7CoreIntegration,
  getCin7OmniIntegration,
  updateCin7CoreIntegration,
  updateCin7OmniIntegration,
  getEbayAuthorizationUrl,
  getGmailRecentMessages,
  getGmailThread,
  getLegacySignedOAuthState,
  getOmsTiktokIntegration,
  getReturnsTiktokIntegration,
  setReturnsTiktokIntegrationSettings,
  disconnectOmsTiktokIntegration,
  disconnectReturnsTiktokIntegration,
  getTiktokAuthorizationExpiration,
  getAmazonAuthUrl,
  getAmazonIntegration,
  getBlueYonderIntegration,
  setBlueYonderIntegration,
  disconnectBlueYonderIntegration,
  getDeposcoIntegration,
  setDeposcoIntegration,
  updateDeposcoIntegration,
  disconnectDeposcoIntegration,
  getFlexportIntegration,
  putFlexportIntegration,
  disconnectFlexportIntegration,
  getInmarIntegration,
  setInmarIntegration,
  disconnectInmarIntegration,
  disconnectWalmartIntegration,
  disconnectFaireIntegration,
  reconnectFaireIntegration,
  authorizeFaireIntegration,
  deleteMasonhubIntegration,
  getMasonhubIntegration,
  putMasonhubIntegration,
  deleteShipbobIntegration,
  getShipbobIntegrations,
  getShipmonkIntegration,
  putShipmonkIntegration,
  deleteShipmonkIntegration,
  getEcwidIntegration,
  putEcwidIntegration,
  deleteEcwidIntegration,
  getTrackstarConnections,
  getTrackstarLinkToken,
  exchangeTrackstarAuthCode,
  updateTrackstarReturnConnectionSettings,
  getWalmartIntegration,
  getFaireIntegration,
  getOmsApparelMagicIntegration,
  getOmsNetsuiteIntegration,
  createOmsNetsuiteIntegration,
  updateOmsNetsuiteIntegration,
  createWooCommerceIntegration,
  getWooCommerceIntegration,
  testWooCommerceConnection,
  updateWooCommerceIntegration,
  getBrightpearlOrderStatuses,
  updateBrightpearlOmsSettings,
  connectTripleWhaleOmsIntegration,
  getTripleWhaleOmsIntegration,
  updateTripleWhaleOmsSettings,
  updateBrightpearlReturnsSettings,
  getGlobalEIntegration,
  setGlobalEIntegration,
  disconnectGlobalEIntegration,
  createLandmarkGlobalIntegration,
  getLandmarkGlobalIntegration,
  getIDFShippingIntegration,
  setIDFShippingIntegration,
  disconnectIDFShippingIntegration,
  getKatanaIntegration,
  setKatanaIntegration,
  disconnectKatanaIntegration,
  getNetSuiteIntegration,
  getNetSuiteOAuthUrl,
  deleteNetSuiteIntegration,
  upsertNetSuiteIntegration,
  testNetSuiteReturnAuthorization,
  retryItemReceiptEvent,
  getLuminousIntegration,
  setLuminousIntegration,
  updateLuminousIntegration,
  disconnectLuminousIntegration,
  getMintsoftIntegration,
  getReturnReasons,
  setMintsoftIntegration,
  disconnectMintsoftIntegration,
  getKlaviyoIntegration,
  setKlaviyoIntegration,
  updateKlaviyoIntegration,
  disconnectKlaviyoIntegration,
  getLoopIntegration,
  setLoopIntegration,
  updateLoopIntegration,
  disconnectLoopIntegration,
  getRefundidIntegration,
  setRefundidIntegration,
  disconnectRefundidIntegration,
  getRyderIntegration,
  updateRyderIntegration,
  disconnectRyderIntegration,
  retryRyderWebhookSubscription,
  getApparelMagicIntegration,
  setApparelMagicIntegration,
  updateApparelMagicIntegration,
  disconnectApparelMagicIntegration,
  getAims360Integration,
  getAllShipViaCodes,
  setAims360Integration,
  updateAims360Integration,
  disconnectAims360Integration,
  getAuthorizeNetIntegration,
  setAuthorizeNetIntegration,
  updateAuthorizeNetIntegration,
  disconnectAuthorizeNetIntegration,
  getCustomReturnIntegration,
  setCustomReturnIntegration,
  disconnectCustomReturnIntegration,
  getCloudXIntegration,
  postCloudXIntegration,
  disconnectCloudXIntegration,
  getReturnBearIntegration,
  setReturnBearIntegration,
  updateReturnBearIntegration,
  disconnectReturnBearIntegration,
  getDropoffTracking,
  getReturnBearExceptions,
  getReturnBearTrackingEvents,
  resolveReturnBearException,
  getRiseAiIntegration,
  initiateRiseAiOAuth,
  setRiseAiIntegration,
  updateRiseAiIntegration,
  disconnectRiseAiIntegration,
  getLoopzIntegration,
  setLoopzIntegration,
  updateLoopzIntegration,
  disconnectLoopzIntegration,
  testLoopzConnection,
  getPurpleDotIntegration,
  setPurpleDotIntegration,
  updatePurpleDotIntegration,
  disconnectPurpleDotIntegration,
  getCreditsYardIntegration,
  setCreditsYardIntegration,
  updateCreditsYardIntegration,
  disconnectCreditsYardIntegration,
  getSekoIntegration,
  setSekoIntegration,
  updateSekoIntegration,
  disconnectSekoIntegration,
  getShipHeroIntegration,
  putShipheroIntegration,
  disconnectShipHeroIntegration,
  shipHeroInventoryAdd,
  validateShipHeroLocation,
  getShipHeroProductBins,
  getShipedgeIntegration,
  putShipedgeIntegration,
  disconnectShipedgeIntegration,
  getCommentsoldIntegration,
  createCommentsoldIntegration,
  deleteCommentsoldIntegration,
  enableOmsOnCommentsoldIntegration,
  updateCommentsoldIntegration,
  getCommentsoldOAuthUrl,
  getBlueCherryIntegration,
  setBlueCherryIntegration,
  disconnectBlueCherryIntegration,
  getOkendoIntegration,
  setOkendoIntegration,
  disconnectOkendoIntegration,
  getTeamworkCommerceIntegration,
  setTeamworkCommerceIntegration,
  disconnectTeamworkCommerceIntegration,
  getParentEasypostIntegration,
  createParentEasypostIntegration,
  updateParentEasypostIntegration,
  deleteParentEasypostIntegration,
  getWayfairIntegration,
  createWayfairIntegration,
  disconnectWayfairIntegration,
};

const coreRpcDefinitions = {
  // brand kit
  generateContactCard,
  processFontFiles,
  updateBrandKit,
  // billing
  createStripeConnectedAccount,
  deletePaymentMethod,
  getPaymentMethodStatus,
  onboardStripeConnectedAccount,
  getStripeConnectedAccount,
  triggerManualPayout,
  // third-party billing accounts
  createThirdPartyBillingAccount,
  deleteThirdPartyBillingAccount,
  getThirdPartyBillingAccounts,
  // address autofill
  getAddressFromSuggestion,
  getAutocompleteSuggestions,
  // addresses
  createAddress,
  deleteAddress,
  getAddresses,
  getAddressCollections,
  getAddressesByIds,
  getOrCreateExternalAddress,
  updateAddress,
  validateInternationalAddresses,
  // work order flows
  getWorkOrderFlows,
  getWorkOrderFlowById,
  createWorkOrderFlow,
  deleteWorkOrderFlow,
  updateWorkOrderFlows,
  updateWorkOrderFlowSteps,
  // advanced flow
  batchUpdateRuleOrder,
  createAdvancedFlow,
  createAdvancedFlowFromDefault,
  deleteAdvancedFlow,
  getAdvancedFlowById,
  getAdvancedFlowCount,
  getAdvancedFlows,
  getAdvancedFlowsByVersionGroupId,
  getProcessingFlowEditorState,
  getRulesByTrigger,
  publishProcessingFlowRevision,
  saveProcessingFlowDraft,
  updateAdvancedFlow,
  // extensions
  uploadExtensionArtifact,
  getExtensionArtifact,
  getExtensionContractTypes,
  // email templates
  createEmailTemplateFromDefault,
  // agent
  redoAi,
  provideAiFeedback,
  provideMessageFeedback,
  // ai summary
  generateAiAnalyticsSummary,
  getAiAnalyticsSummary,
  // faq
  createArticle,
  createCollection,
  createFaqPage,
  deleteArticle,
  deleteCollection,
  deleteFaqPage,
  getFaq,
  getFaqArticles,
  getFaqCollections,
  getFaqPages,
  getFaqTheme,
  updateArticle,
  updateCollection,
  updateFaqPage,
  updateTheme,
  // collection
  getCollectionInfoByIds,
  getCollections,
  getWorkflowStatus,
  createRmaForReturn,
  triggerEmailFlowPreview,
  sendEmailFromTemplate,
  getValidReturnTrackingTriggers,
  // managed claims
  getManagedClaimStatus,
  fastTrackClaim,
} as const;

const orderRpcDefinitions = {
  // order
  addLocation,
  deleteLocation,
  updateLocation,
  updateLocationShippingName,
  addOutboundFunds,
  cancelPickup,
  createPickup,
  requestRecurringPickup,
  searchPickups,
  searchPickupsCount,
  getPendingUpsPickups,
  authorizeUspsCarrierAccount,
  verifyUspsContractRatesLinked,
  unverifyUspsContractRates,
  createCarrierAccount,
  createDirectFedexCarrierAccount,
  deleteCarrierAccount,
  easypostFedexMfaAddressValidation,
  easypostFedexMfaGeneratePin,
  easypostFedexMfaValidatePin,
  easypostFedexMfaValidateInvoice,
  syncOrder,
  syncOrderByProviderId,
  generateFedexPin,
  getCarrierAccounts,
  parseFedexInvoicePdf,
  submitFedexMfaData,
  submitFedexMfaBackup,
  getLocations,
  getLocationsForRoutingRules,
  getLocationsWithFulfillsFor,
  resetOrderFlow,
  getFirstReturnForOrder,
  getOrdersWithPickStatus,
  getTeamOrdersByEmail,
  checkOrdersReturnability,
  // order edits
  getEditSourceCounts,
  getEditTypeCounts,
  getUpsellRevenue,
  searchOrderEdits,
  searchOrderEditsCount,
  // packing
  createPackingSlipTemplate,
  deletePackingSlipTemplate,
  getPackingSlipTemplate,
  getPackingSlipTemplatesByTeam,
  updatePackingSlipTemplate,
  // product
  getProduct,
  getProductVendors,
  searchProducts,
  searchProductTags,
  // shopify
  getShopifyPlan,
  refreshShopifyPlan,
  getCartValidationFunctionStatus,
  toggleCartValidationFunction,
  // repair
  getRepairInvoiceDetails,
  sendRepairInvoice,
  updateRepairInvoice,
  // rate calculator
  getRateCalculatorRates,
} as const;

const productsAsVariantsRpcDefinitions = {
  syncProductsAsVariants,
  testProductsAsVariantsConfigurations,
  updateProductsAsVariantsConfigurations,
  getProductsAsVariantsConfigurations,
  getProductIdToProductAsVariantProductIds,
} as const;

const merchantRecommendedExchangesRpcDefinitions = {
  getProductsForExchangeGrouping,
  getMerchantRecommendedExchanges,
  updateMerchantRecommendedExchanges,
} as const;

const variantExchangeGuidanceRpcDefinitions = {
  getVariantExchangeGuidance,
  getProductsForVariantExchangeGuidance,
  updateVariantExchangeGuidance,
} as const;

const exchangeAgentGuidanceRpcDefinitions = {
  createExchangeAgentGuidance,
  deleteExchangeAgentGuidance,
  listExchangeAgentGuidance,
  updateExchangeAgentGuidance,
  renameExchangeAgentGuidance,
} as const;

const supportRpcDefinitions = {
  // return page details
  getAiChats,
  getAiReturnReasonsConversation,
  getProductVariantMetafields,
  getReturnItemBinLocation,
  getReturnOrderNotes,
  getReturnVerification,
  getReturnWmsEvents,
  getRivoCustomerLoyalty,
  refundExchangeShipping,
  // returns
  submitReturnShippingClaim,
  // support
  createCallAvailability,
  deleteRecordingFromCallRecord,
  getCallRecordWithTranscript,
  generatePdfForInvoice,
  getCsatResponsesForConversation,
  getCsatResponsesForTeam,
  getCsatResponsesForTeamCount,
  getPhoneNumberForTeam,
  getSupportAiPricing,
  getSupportBillingInvoices,
  getTeamCallAvailabilities,
  getTelnyxTelephonyToken,
  hasReachedConversationThreshold,
  manuallyConvertChatToEmail,
  polishMessage,
  searchTelnyxPhoneNumbers,
  setupPhoneNumber,
  toggleCallBeingRecorded,
  toggleCallOnHold,
  turnOnSupportDefaults,
  updateAiFeedbackOnMessage,
  updateSupportSettings,
  getConversationTagsById,
  getConversationInsights,
  getConversationInsightsCount,
  grantFreeTrialCredits,
  // tag
  deleteTag,
  editTag,
  getTagsByTagGroup,
  getTeamTags,
  upsertTag,
  // tag groups
  createTagGroup,
  deleteTagGroup,
  getTagGroups,
  updateTagGroup,
  // teams
  watchTeamEvents,
  // team settings
  getPickedSettings,
  updatePickedSettings,
  // portal customization
  getPortalCustomization,
  updatePortalCustomization,
} as const;

const miscRpcDefinitions = {
  // cart optimization
  editCartOptimizationSettings,
  // try first
  checkShopifySelector,
  editTryFirstPlan,
  getTryFirstPlan,
  updateTryFirstWidgetSettings,
  getTnplContractStatus,
  // upsell
  createUpsellPage,
  updateUpsellPage,
  getUpsellPage,
  // warranty
  getWarrantyRegistration,
  getWarrantyRegistrations,
  getWarrantyRegistrationsCount,
  updateWarrantyRegistrationProduct,
  updateWarrantyRegistrationCustomItem,
  submitWarrantyRegistration,
  // yofi
  getCustomerYofiScores,
  // gift receipt requests
  getGiftReceiptRequests,
  updateGiftReceiptRequestStatus,
  // inmar blind returns
  getInmarBlindReturns,
  updateInmarBlindReturnStatus,
  // other
  calculateNewOrderValue,
  // global search
  getGlobalSearchResults,
  generateFlowAgentResponse,
  createCustomerAuthToken,
  createOrderComment,
  createReport,
  getCustomer,
  getCustomerByEmail,
  getCustomerTags,
  deleteReport,
  disconnectRivoIntegration,
  getUserPin,
  adjustLoyaltyPoints,
  getAiExchangeAgentAnalytics,
  getPortalEvents,
  getPortalOptimizationState,
  getBundlesData,
  getClaimAttachmentRateSeriesData,
  getClaimsAnalyticsStatistics,
  getCustomerAccountsMetricsForOverview,
  getDraftReturn,
  getEmailTemplateNames,
  getExchangeRates,
  getIndustryCategoryComparisonStats,
  getLabelRates,
  getNativeAccountsSettings,
  getOperationsNewTotals,
  getOrCreateCustomerFromPhoneNumber,
  getOrderId,
  getOrder,
  getOrders,
  cancelOrder,
  getBatchTnplContractStatus,
  getOriginDiscounts,
  getProductBenchmark,
  getProductTitles,
  getRedoSalesChannels,
  getCustomAnalyticsReport,
  getCustomAnalyticsReportFilterOptions,
  getCustomAnalyticsReportRows,
  deleteCustomAnalyticsReport,
  listCustomAnalyticsReportRevisions,
  regenerateCustomAnalyticsReport,
  restoreCustomAnalyticsReportRevision,
  updateCustomAnalyticsReportTitle,
  getReport,
  getReports,
  listCustomAnalyticsReports,
  streamCustomAnalyticsReportData,
  get3plDashboardMetrics,
  get3plLeaderboard,
  getReturnAnalyticsByProduct,
  getReturnAnalyticsByVariant,
  getReturnAnalyticsSeriesData,
  getReturnAnalyticsStatistics,
  getReturnOperationsKeyStats,
  getTryFirstAnalytics,
  streamReturnedLineItemsReportData,
  streamReturnsReportData,
  streamOrderedLineItemsReportData,
  streamWarrantyCustomersReportData,
  streamPurchasedExtendedWarrantyReportData,
  getReturnsInstantExchangeRecoveryHistory,
  getRivoIntegration,
  getSalesChannelOptions,
  getUncoveredSalesChannelWarnings,
  getSaveForLaterStorefrontDisplaySettings,
  getTags,
  getUpsellPageAnalytics,
  getPostPurchaseAnalyticsByCheckoutToken,
  getUpsellProductAnalytics,
  getValidIndustryCategories,
  getVendorNames,
  getOrderSourceNames,
  getWarehouseForProduct,
  issueStoreCreditToCustomer,
  processReturn,
  attemptReturnPickupRefund,
  rescheduleReturnPickup,
  scheduleReturnPickup,
  purchaseLabel,
  removeVariantExchangeItem,
  resendExternalReturnShippingProviderLabel,
  resendEmail,
  resendLabel,
  resendGiftCard,
  restockItemsForReturn,
  searchProductVariants,
  getVariantById,
  setRedoSalesChannels,
  setReturnItemDisposition,
  setRivoIntegration,
  updateCustomerWidgetSettings,
  updateAllCustomerWidgetSettings,
  updateNativeAccountsSettings,
  // web pixel
  activateWebPixelSetting,
  deactivateWebPixelSetting,
  updateNewOrderItems,
  updateReport,
  findPreviousReturnShippingRefunds,
  updateReturnWithShippingRefund,
  updateReturnWithWaivedDraftFee,
  updateReturnWithWaivedShippingFee,
  updateSaveForLaterStorefrontDisplaySettings,
  getReturnsCount,
  getReturnsPagination,
  getReturnTotals,
  getReturnTotalsFeatureFlag,
  getReturn,
  getReturnLifecycle,
  getFraudZipCodeStats,
  watchReturn,
  uploadBundles,
  uploadSkuGroupingCsv,
  importInternationalCustomsCsv,
  getImportInternationalCustomsCsvStatus,
  getUploadBundlesStatus,
  // return views
  createReturnViewFolder,
  deleteReturnView,
  deleteReturnViewFolder,
  getReturnViewNotificationCounts,
  getReturnViewsAndFolders,
  saveReturnView,
  saveReturnViewsAndFolders,
  updateReturnViewFolderName,
  updatePosSettings,
  updateReturnPermissions,
  addTagToReturn,
  removeTagFromReturn,
  setMerchantFraudFeedback,
  dismissCreateShipmentFailure,
  dismissRmaCreationFailure,
  enableAiExchangeAgent,
  getCurrentReturnAiExchangeAgentInvoice,
  getFinalizedReturnAiExchangeAgentInvoices,
  getCurrentReturnsInvoice,
  getFinalizedReturnsInvoices,
  updateProductReturn,
  updateReturnAdjustment,
  updateReturnCustomerContact,
  changePendingLockStatus,
  // speech-to-text
  speechToText,
  // payout invoices
  getPayoutInvoiceCsv,
  getPayoutInvoicePdf,
} as const;
const merchantRpcDefinitions = {
  streamAeoAssistant,
  respondToAeoAssistantTool,
  confirmAeoAssistantTool,
  getAeoAssistantThreadMessages,
  listAeoAssistantThreads,
  saveAeoAssistantThread,
  messageMerchantSupportAgent,
  streamMerchantSupportAgent,
  getMerchantSupportAgentThreads,
  getMerchantSupportAgentThread,
  streamAskRedo,
  getAskRedoEmergencyMode,
  getAskRedoThreads,
  getAskRedoThread,
  queryDom,
  checkActiveEscalation,
  createEscalation,
  getEscalation,
  getEscalationMessages,
  markEscalationRead,
  sendEscalationMessage,
  shouldShowEscalationCsat,
  submitEscalationCsat,
  watchEscalationEvents,
  acceptLabelsUpsell,
} as const;

const ecommerceRpcDefinitions = {
  // bigcommerce
  getBigcommerceIntegration,
  setBigcommerceExchangeOrderStatus,
  setBigcommerceRefundMethod,
  setBigcommerceStoreCreditType,
  // shopify
  getShopifyIntegration,
  setShopifyRefundMethod,
  // integrations
  getEnabledProviders: getEnabledFulfillmentProviders,
  getTeamEcommerceProviders,
  getMarketingEcommerceProviders,
} as const;

const aeoRpcDefinitions = {
  addAeoPrompts,
  archiveAeoPrompts,
  dismissAeoRecommendation,
  generateAeoPrompts,
  restoreAeoRecommendation,
  getAeoPromptDetails,
  getAeoPromptResponseDetail,
  getAeoPromptResponseSourceCounts,
  getAeoPromptResponses,
  getAeoRecommendations,
  getAeoPromptSummary,
  getAeoPrompts,
  getAeoDashboardCitations,
  getAeoDashboardFilterOptions,
  getAeoDashboardShareOfVoice,
  getAeoDashboardTopicPrompts,
  getAeoDashboardTopics,
  getAeoDashboardVisibility,
  getBrandCompetitors,
  getBrandIdentityGuide,
  getBrandVisibilityOverTime,
  getCompetitorComparison,
  getCurrentAeoInvoice,
  getDashboardMetrics,
  getFinalizedAeoInvoices,
  getModelPerformance,
  getSources,
  unarchiveAeoPrompts,
  updateAeoPromptBranded,
  updateAeoRecommendationFeedback,
  getAeoOnboardingProgress,
  createAeoPromptTopic,
  deleteAeoPromptTopic,
  getAeoPromptTopics,
  setAeoPromptTopics,
  updateAeoPromptTopic,
  bulkAddTopicsToPrompts,
  bulkRemoveTopicsFromPrompts,
} as const;

const imsRpcDefinitions = {
  getCurrentImsInvoice,
  getFinalizedImsInvoices,
  getCurrentImsForecastingInvoice,
  getFinalizedImsForecastingInvoices,
  getPoEmailSettings,
  sendTestPoEmail,
  updatePoEmailSettings,
} as const;

const spotlightRpcDefinitions = {
  getSpotlights,
  getSpotlight,
  createSpotlight,
  updateSpotlight,
  deleteSpotlight,
  duplicateSpotlight,
  getSpotlightSplits,
  createSpotlightSplit,
  updateSpotlightSplitStatus,
} as const;

const aiToneAndVoiceRpcDefinitions = {
  initializeAiToneAndVoice,
  getAiToneAndVoiceSettings,
  updateAiToneAndVoiceSettings,
  getConciergePhoneReadiness,
  provisionConciergePhoneNumber,
} as const;

const brandSummaryRpcDefinitions = {
  getBrandSummary,
  updateBrandSummary,
} as const;

const contextualRpcDefinitions = {
  enableContextual,
  disableContextual,
  getContextualSettings,
} as const;

const disputeRpcDefinitions = {
  enableDisputes,
  enableDisputesBilling,
  getDispute,
  getDisputeDashboardStats,
  getDisputes,
  getShopPolicies,
  submitDisputeEvidence,
  updateDisputeEvidence,
  updateShopPolicy,
  generateAllEvidence,
  toggleDisputeAutoEvidence,
  getPayPalAuthUrl,
  getReclaimAccessDefaults,
  getShopifyPermissionsUpdateUrl,
  getPayPalConnectionStatus,
  disconnectPayPalIntegration,
  getStripeConnectionStatus,
  connectStripeIntegration,
  disconnectStripeIntegration,
  getGorgiasConnectionStatus,
  disconnectGorgiasIntegration,
  getDisputeGorgiasTickets,
  redeemReclaimPartnerCode,
  validateReclaimPartnerCode,
} as const;

const merchantEmailRpcDefinitions = {
  fireMerchantEmailTrigger: fireMerchantEmailTriggerRpc,
} as const;

const redoSuppliesRpcDefinitions = {
  createCheckoutSession,
  getCheckoutSession,
  getRedoSuppliesOrder,
  getRedoSuppliesOrderFulfillmentGroups,
  getRedoSuppliesOrders,
  getRedoSuppliesOrdersCount,
  handleRedoSuppliesCheckoutCompleted,
  getRedoCart,
  getRedoSuppliesProductDetail,
  getRedoSuppliesProducts,
  getSuppliesInventoryConfigs,
  getSuppliesInventoryConfigsCount,
  setCartDestinationLocation,
  updateSuppliesInventoryConfig,
  upsertRedoCartItems,
} as const;

const freightRpcDefinitions = {
  createFreightDeliveryAccessorialPreset,
  createFreightHandlingUnit,
  createFreightPickupAccessorialPreset,
  createFreightPickupWindow,
  deleteFreightDeliveryAccessorialPreset,
  deleteFreightHandlingUnit,
  deleteFreightPickupAccessorialPreset,
  deleteFreightPickupWindow,
  generateFreightQuotes,
  getFreightDeliveryAccessorialPresets,
  getFreightHandlingUnits,
  getFreightPickupAccessorialPresets,
  getFreightPickupWindows,
  purchaseFreightBooking,
  setDefaultFreightDeliveryAccessorialPreset,
  setDefaultFreightHandlingUnit,
  setDefaultFreightPickupAccessorialPreset,
  setDefaultFreightPickupWindow,
} as const;

const unifiedBillingRpcDefinitions = {
  exportBillCsv,
  generatePdfForBill,
  getAccountBillingSettings,
  getBills,
  getBillDetails,
  getBillingChargesAndTransactions,
} as const;

const webhookRpcDefinitions = {
  getWebhookEvents,
  getTeamWebhooks,
  setTeamWebhooks,
} as const;

const apiTokenRpcDefinitions = {
  createApiToken,
  listApiTokens,
  updateApiToken,
  revokeApiToken,
} as const;

export const rpcDefinition: typeof coreRpcDefinitions &
  typeof orderRpcDefinitions &
  typeof supportRpcDefinitions &
  typeof miscRpcDefinitions &
  typeof ecommerceRpcDefinitions &
  typeof returnAssessmentDefinitions &
  typeof merchantRpcDefinitions &
  typeof productsAsVariantsRpcDefinitions &
  typeof merchantRecommendedExchangesRpcDefinitions &
  typeof variantExchangeGuidanceRpcDefinitions &
  typeof exchangeAgentGuidanceRpcDefinitions &
  typeof integrationRpcDefinitions &
  typeof aeoRpcDefinitions &
  typeof imsRpcDefinitions &
  typeof spotlightRpcDefinitions &
  typeof aiToneAndVoiceRpcDefinitions &
  typeof brandSummaryRpcDefinitions &
  typeof contextualRpcDefinitions &
  typeof disputeRpcDefinitions &
  typeof merchantEmailRpcDefinitions &
  typeof freightRpcDefinitions &
  typeof redoSuppliesRpcDefinitions &
  typeof unifiedBillingRpcDefinitions &
  typeof webhookRpcDefinitions &
  typeof apiTokenRpcDefinitions &
  typeof localizationRpcDefinitions = {
  ...coreRpcDefinitions,
  ...orderRpcDefinitions,
  ...supportRpcDefinitions,
  ...miscRpcDefinitions,
  ...ecommerceRpcDefinitions,
  ...merchantRpcDefinitions,
  ...returnAssessmentDefinitions,
  ...integrationRpcDefinitions,
  ...productsAsVariantsRpcDefinitions,
  ...merchantRecommendedExchangesRpcDefinitions,
  ...variantExchangeGuidanceRpcDefinitions,
  ...exchangeAgentGuidanceRpcDefinitions,
  ...aeoRpcDefinitions,
  ...imsRpcDefinitions,
  ...spotlightRpcDefinitions,
  ...aiToneAndVoiceRpcDefinitions,
  ...brandSummaryRpcDefinitions,
  ...contextualRpcDefinitions,
  ...disputeRpcDefinitions,
  ...merchantEmailRpcDefinitions,
  ...freightRpcDefinitions,
  ...redoSuppliesRpcDefinitions,
  ...unifiedBillingRpcDefinitions,
  ...webhookRpcDefinitions,
  ...apiTokenRpcDefinitions,
  ...localizationRpcDefinitions,
};

// Performance optimization: Pre-compute group types separately instead of one giant
// InferRpcDefinition<typeof rpcDefinition>. This allows TypeScript to cache intermediate
// type computations rather than re-inferring ~300+ endpoints in a single pass.
// Reduces emit time from ~10.4s to ~2.3s (4.5x faster).
// See: https://github.com/microsoft/TypeScript/wiki/Performance#preferring-interfaces-over-intersections
type CoreRpc = InferRpcDefinition<typeof coreRpcDefinitions>;
type OrderRpc = InferRpcDefinition<typeof orderRpcDefinitions>;
type SupportRpc = InferRpcDefinition<typeof supportRpcDefinitions>;
type MiscRpc = InferRpcDefinition<typeof miscRpcDefinitions>;
type EcommerceRpc = InferRpcDefinition<typeof ecommerceRpcDefinitions>;
type ReturnAssessmentRpc = InferRpcDefinition<
  typeof returnAssessmentDefinitions
>;
type MerchantRpc = InferRpcDefinition<typeof merchantRpcDefinitions>;
type ProductsAsVariantsRpc = InferRpcDefinition<
  typeof productsAsVariantsRpcDefinitions
>;
type MerchantRecommendedExchangesRpc = InferRpcDefinition<
  typeof merchantRecommendedExchangesRpcDefinitions
>;
type VariantExchangeGuidanceRpc = InferRpcDefinition<
  typeof variantExchangeGuidanceRpcDefinitions
>;
type ExchangeAgentGuidanceRpc = InferRpcDefinition<
  typeof exchangeAgentGuidanceRpcDefinitions
>;
type IntegrationRpc = InferRpcDefinition<typeof integrationRpcDefinitions>;
type AeoRpc = InferRpcDefinition<typeof aeoRpcDefinitions>;
type ImsRpc = InferRpcDefinition<typeof imsRpcDefinitions>;
type SpotlightRpc = InferRpcDefinition<typeof spotlightRpcDefinitions>;
type AiToneAndVoiceRpc = InferRpcDefinition<
  typeof aiToneAndVoiceRpcDefinitions
>;
type BrandSummaryRpc = InferRpcDefinition<typeof brandSummaryRpcDefinitions>;
type ContextualRpc = InferRpcDefinition<typeof contextualRpcDefinitions>;
type DisputeRpc = InferRpcDefinition<typeof disputeRpcDefinitions>;
type MerchantEmailRpc = InferRpcDefinition<typeof merchantEmailRpcDefinitions>;
type FreightRpc = InferRpcDefinition<typeof freightRpcDefinitions>;
type RedoSuppliesRpc = InferRpcDefinition<typeof redoSuppliesRpcDefinitions>;
type UnifiedBillingRpc = InferRpcDefinition<
  typeof unifiedBillingRpcDefinitions
>;
type WebhookRpc = InferRpcDefinition<typeof webhookRpcDefinitions>;
type ApiTokenRpc = InferRpcDefinition<typeof apiTokenRpcDefinitions>;
type LocalizationRpc = InferRpcDefinition<typeof localizationRpcDefinitions>;

export type RedoMerchantRpcDefinition = CoreRpc &
  OrderRpc &
  SupportRpc &
  MiscRpc &
  EcommerceRpc &
  ReturnAssessmentRpc &
  MerchantRpc &
  ProductsAsVariantsRpc &
  MerchantRecommendedExchangesRpc &
  VariantExchangeGuidanceRpc &
  ExchangeAgentGuidanceRpc &
  IntegrationRpc &
  AeoRpc &
  ImsRpc &
  SpotlightRpc &
  AiToneAndVoiceRpc &
  BrandSummaryRpc &
  ContextualRpc &
  DisputeRpc &
  MerchantEmailRpc &
  FreightRpc &
  RedoSuppliesRpc &
  UnifiedBillingRpc &
  WebhookRpc &
  ApiTokenRpc &
  LocalizationRpc;
